module.exports = __webpack_public_path__ + "img/mk.095cedf2.svg";